import React, { useMemo } from "react";
import { IStyleProps } from "@/ui-component/interface";
import classnames from "classnames";
import styles from "./customCarousel.module.scss";

interface IDot {
    active: boolean;
    index: number;
    onClick: Function;
}

const CustomDot: React.FC<IDot> = (props) => {
    const { onClick, active } = props;

    return (
        <button
            className={styles.dotWrapper}
            onClick={(e) => onClick(e, props.index)}
        >
            <div 
                className={classnames(
                    styles.dotContent,
                    active ? styles.dotActive : styles.dotInactive
                )}
            />
        </button>
    );
};

interface IPaginationProps extends IStyleProps {
    dots: number;
    index: number;
    onChangeIndex: Function;
}

const CustomPagination: React.FC<IPaginationProps> = (props) => {
    const { onChangeIndex, index, dots } = props;

    const children = useMemo(() => {
        const resArr = [];
        for (let i = 0; i < dots; i += 1) {
            resArr.push(
                <CustomDot
                    key={i}
                    index={i}
                    active={i === index}
                    onClick={(e: any) => onChangeIndex(i)}
                />,
            );
        }
        return resArr;
    }, [dots, index, onChangeIndex]);

    return (
        <div
            className={classnames(styles.dotRoot, props.className)}
        >
            {children}
        </div>
    );
};

export default CustomPagination;
